import { InputField } from './InputField';
import { ScrollView } from './ScrollView';
import { ImageBackground } from './ImageBackground';

export const custom = {
  InputField,
  ScrollView,
  ImageBackground,
};
